import { i18n as printLiquidation } from "../printLiquidationReport";
import en from "./en";
import es from "./es";

export default {
  en: { ...en, ...printLiquidation.en },
  es: { ...es, ...printLiquidation.es },
};
